<template>
  <span class="progress-circular" :style="computedColor">
    <span class="loader" />
    <span class="loader-aux" />
  </span>
</template>

<script>

export default {
  name: 'VProgressCircular',
  props: {
    color: {
      type: String,
      default: 'gray',
    }
  },
  computed: {
    computedColor() {
      return {
        '--var-color': 'var(--vx-' + this.color + ')' ?? 'var(--vx-gray-light)',
      };
    },
  }
};
</script>

<style lang="scss" scoped>
@import "VProgressCircular";
</style>
